<template>
  <div class="message-mask">
    <div class="prev-premium-upgrade-cta">
      <MessagesIllustration class="mx-auto" />
      <p class="heading-4 mt-24">Pick up the conversation with your sitters</p>
      <p class="my-24 text-body">Upgrade to premium to access your previous messages and continue the conversation</p>
      <Button value="view pricing" variant="primary" size="medium" href="/upgrade/pricing" @click="trackViewPricingButton" />
    </div>
  </div>
</template>

<script lang="ts">
import Button from '../../../components/button/Button.vue';
import MessagesIllustration from '../../../graphics/illustrations/MessagesIllustration.vue';
import { sendSegmentEvent } from '../../../lib/segment';

export default {
  name: 'UpgradePrompt',
  components: {
    MessagesIllustration,
    Button,
  },
  methods: {
    trackViewPricingButton() {
      sendSegmentEvent('Messaging See Pricing', {});
    },
  },
};
</script>
